"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENTITY_DISPLAY_NAME = exports.ENTITY_TYPE = exports.REPORT = exports.SEGMENT = exports.BULK = exports.EXPERIENCE = exports.SUCCESS_PLAY = exports.CAMPAIGN = void 0;
exports.CAMPAIGN = 'campaign';
exports.SUCCESS_PLAY = 'successplay';
exports.EXPERIENCE = 'experience';
exports.BULK = 'bulk';
exports.SEGMENT = 'segment';
exports.REPORT = 'report';
exports.ENTITY_TYPE = [exports.CAMPAIGN, exports.SUCCESS_PLAY, exports.EXPERIENCE];
exports.ENTITY_DISPLAY_NAME = {
    [exports.CAMPAIGN]: 'Campaign',
    [exports.SUCCESS_PLAY]: 'SuccessPlay',
    [exports.EXPERIENCE]: 'Experience',
};
//# sourceMappingURL=resources.js.map